<template>
  <div class="menu-container">
    <el-menu 
      :default-active="$route.path" 
      :collapse="false"
      class="menu"
      @open="handleOpen" 
      @close="handleClose" 
      :default-openeds="openeds" 
      router>
      
      <div class="menu-header">
        <span class="menu-title">功能菜单</span>
      </div>

      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-menu menu-icon"></i>
          <span class="menu-text">基本操作</span>
        </template>

        <el-tooltip effect="dark" content="导入现有的excel表格文件,制作手机端填写表格" placement="right">
          <el-menu-item index="/import_data_excel">
            <span class="item-dot"></span>
            <span class="item-text">手工导入Excel</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip effect="dark" content="导入现有的excel表格文件,制作手机端填写表格" placement="right">
          <el-menu-item index="/import_data_excel_ai">
            <span class="item-dot"></span>
            <span class="item-text">智能导入Excel</span>
          </el-menu-item>
        </el-tooltip>

        <el-tooltip effect="dark" content="管理我发出去的核对表" placement="right">
          <el-menu-item index="/query_list">
            <span class="item-dot"></span>
            <span class="item-text">管理核对表</span>
          </el-menu-item>
        </el-tooltip>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'MenuList',
  data: function() {
    return {
      openeds: ['1'],
      username: '',
      activeIndex: ''
    }
  },
  created() {
    this.username = this.$session.get('USERNAME')
    this.setCurrentRoute()
  },
  watch: {
    $route() {
      this.setCurrentRoute()
    }
  },
  methods: {
    setCurrentRoute() {
      this.activeIndex = this.$route.path
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>

<style scoped>
.menu-container {
  height: 100%;
  background: #fff;
  border-right: 1px solid #e8ecf1;
}

.menu {
  border-right: none;
  background: transparent;
}

.menu-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.menu-title {
  font-size: 13px;
  font-weight: 600;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.menu-icon {
  color: #1485FB;
  font-size: 18px;
  margin-right: 8px;
}

.menu-text {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}

/* 子菜单样式 */
.menu >>> .el-submenu__title {
  height: 50px;
  line-height: 50px;
  padding: 0 20px !important;
  transition: all 0.2s;
}

.menu >>> .el-submenu__title:hover {
  background: rgba(20, 133, 251, 0.06) !important;
}

.menu >>> .el-submenu__title i.el-submenu__icon-arrow {
  color: #999;
}

/* 菜单项样式 */
.menu >>> .el-menu-item {
  height: 44px;
  line-height: 44px;
  padding: 0 20px 0 48px !important;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}

.menu >>> .el-menu-item:hover {
  background: rgba(20, 133, 251, 0.06) !important;
  color: #1485FB !important;
}

.menu >>> .el-menu-item.is-active {
  background: rgba(20, 133, 251, 0.1) !important;
  color: #1485FB !important;
  border-left-color: #1485FB;
  font-weight: 500;
}

.item-dot {
  width: 6px;
  height: 6px;
  background: #ddd;
  border-radius: 50%;
  transition: all 0.2s;
}

.menu >>> .el-menu-item.is-active .item-dot {
  background: #1485FB;
}

.item-text {
  font-size: 14px;
}

/* 嵌套菜单样式 */
.menu >>> .el-submenu .el-menu {
  background: transparent !important;
}

/* tooltip 样式覆盖 */
.menu >>> .el-tooltip__popper {
  max-width: 200px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue